import React from 'react';
import PropTypes from 'prop-types';
import { Toast } from '@tempmee/react';
import { usePayoutUpload, STEP } from './hooks/usePayoutUpload';
import { PayoutSelectStep } from './PayoutSelectStep';
import { PayoutReviewStep } from './PayoutReviewStep';
import { PayoutSummaryStep } from './PayoutSummaryStep';

// Orchestrates the payout upload flow: select promotion + CSV → review →
// submit → result summary. All logic lives in usePayoutUpload; each step is a
// presentational component.
export const PayoutUploadModal = ({ promotion, onClose }) => {
  const {
    step,
    activePromotions,
    selectedId,
    setSelectedId,
    file,
    fileInputRef,
    handleFileChange,
    isReading,
    review,
    result,
    isSubmitting,
    handleUpload,
    handleSubmit,
    goBack,
    errorToast,
    clearErrorToast,
  } = usePayoutUpload({ promotion });

  let content;
  if (step === STEP.SUMMARY && result) {
    content = <PayoutSummaryStep result={result} onClose={onClose} />;
  } else if (step === STEP.REVIEW && review) {
    content = (
      <PayoutReviewStep
        review={review}
        onSubmit={handleSubmit}
        onBack={goBack}
        isSubmitting={isSubmitting}
      />
    );
  } else {
    content = (
      <PayoutSelectStep
        activePromotions={activePromotions}
        selectedId={selectedId}
        setSelectedId={setSelectedId}
        file={file}
        fileInputRef={fileInputRef}
        onFileChange={handleFileChange}
        onUpload={handleUpload}
        isReading={isReading}
        onClose={onClose}
      />
    );
  }

  return (
    <>
      {content}
      <Toast
        open={!!errorToast}
        severity="error"
        message={errorToast}
        onClose={clearErrorToast}
        autoHideDuration={5000}
      />
    </>
  );
};

PayoutUploadModal.propTypes = {
  promotion: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    maxValueCents: PropTypes.number,
    isDisabled: PropTypes.bool,
  }),
  onClose: PropTypes.func.isRequired,
};

PayoutUploadModal.defaultProps = {
  promotion: null,
};
